// src/store/pipeline.js

// -- Action Type Constants --
const SET_FETCHED_SELECTIONS = "SET_FETCHED_SELECTIONS";
const SET_FETCHED_SELECTIONS_KEY = "SET_FETCHED_SELECTIONS_KEY";
const CLEAR_FETCHED_SELECTIONS = "CLEAR_FETCHED_SELECTIONS";

// -- Initial State --
const initialState = {
  fileDocGroupAndTypes: null, // {}
};

// -- Reducer --
export default function fetchedSelectionsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FETCHED_SELECTIONS:
      // replace entire state
      return action.payload;

    case SET_FETCHED_SELECTIONS_KEY: {
      const { key, value } = action.payload;
      // if nothing changed, return old state
      if (state[key] === value) {
        return state;
      }
      // shallow‐copy + override one key
      return {
        ...state,
        [key]: value,
      };
    }

    case CLEAR_FETCHED_SELECTIONS:
      // reset to initial (same object reference every time)
      return initialState;

    default:
      return state;
  }
}

// — action creators —
// implicit return, minimal object creation

export const fetchedSelectionsSet = (payload) => ({
  type: SET_FETCHED_SELECTIONS,
  payload,
});

export const fetchedSelectionsClear = (payload) => ({
  type: CLEAR_FETCHED_SELECTIONS,
  payload,
});

export const fetchedSelectionsSetKey = (key, value) => ({
  type: SET_FETCHED_SELECTIONS_KEY,
  payload: { key, value },
});

export const fetchedSelectionsClearKey = (key) => ({
  type: SET_FETCHED_SELECTIONS_KEY,
  payload: { key, value: null },
});

// set individual fields
export const fetchedSelectionsSetFileDocGroupAndTypes = (
  fileDocGroupAndTypes
) => ({
  type: SET_FETCHED_SELECTIONS_KEY,
  payload: { key: "fileDocGroupAndTypes", value: fileDocGroupAndTypes },
});
